import Canvas from './Canvas';
import { useEffect, useState } from 'react';
import * as msc from "mascot-vis";
import EventLayer from './EventLayer';
import ToolBar from './ToolBar';
import Inspector from './Inspector';
import LayerView from './LayerView';
import DataPanel from './DataPanel';
import './css/App.css';
import store from "./store";
import { select } from "./canvasSlice";

function Templating(props) {
    const renderer = msc.renderer("svg", "canvas");
    const [scene, setScene] = useState(msc.scene());
    const [spec, setSpec] = useState('BarChartHorz');
  
    useEffect(() => {
      document.body.style.backgroundColor = "#ddd";
      document.body.style.overflow = "hidden";
    }, [])
  
    useEffect(() => {
      loadScene("specs/" + spec + ".json");
    }, [spec]);
  
    useEffect(() => {
      renderer.clear();
      renderer.render(scene);
    }, [renderer, scene]);
  
    const loadScene = async (url) => {
      const spec = await loadJSON(url);
      let exe = msc.specExecutor();
      let scene = await exe.run(spec);
      store.dispatch(select([]));
      setScene(scene);
    }
  
    const demos = [
      "BarChartHorz",
      "BarChartVert",
      "BoxPlot",
      "BulletChart",
      "DivergingBarChart",
      "GanttChart",
      "GroupedBarChart",
      "HeatMap",
      "Histogram",
      "MosaicPlot",
      "StackedBarChart",
      "TowerChart",
      "Treemap",
      "WaffleChart",
      "WaterfallChart"
    ]
  
    return (
      <div style={{overflow: "hidden"}}>
        <Canvas scene={scene} renderer={renderer} type="svg"></Canvas>
        <EventLayer scene={scene} renderer={renderer}></EventLayer>
        <div id="specList">
          <ul>
            {demos.map(d => <li key={d} onClick={(e) => setSpec(d)}>{d}</li>)}
          </ul>
        </div>
        <DataPanel scene={scene} renderer={renderer}></DataPanel>
        <LayerView scene={scene} renderer={renderer}></LayerView>
        <Inspector scene={scene} renderer={renderer}></Inspector>
        <ToolBar></ToolBar>
      </div>
    )
}

async function loadJSON(url) {
    const response = await fetch(url);
    const text = await response.text();
    let json = JSON.parse(text);
    return json;
  }

export default Templating;